import { Inject, Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { ApiEndpointsService } from './api-endpoints.service';

import { IHttpService } from './ihttp.service';
import { environment } from 'src/environments/environment';
import { UserSSOModel } from '../classes/userSSO';
import { MEMBERS } from '../variables/members';

@Injectable()
export class CecService {

  constructor(
    private apiEndpointsService: ApiEndpointsService,
    @Inject('HttpService') private httpService: IHttpService
  ) { }

  getUserName(): Observable<any> {
    return this.httpService.get(this.apiEndpointsService.getMeEndpoint());
  }

  getUserSapIds(): Observable<any> {
    return this.httpService.get(this.apiEndpointsService.getSapIdEndpoint());
  }


  getIsAdmin(username: string): BehaviorSubject<Boolean> {
    let obsReturn$ = new BehaviorSubject<Boolean>(false);

    obsReturn$ = this.getMembersVar(username);

    // this.httpService.get(environment.GET_TOKEN_OCM).subscribe((result) => {
    //   console.log('token');
    //   console.log(result);
    //   if (
    //     result != null &&
    //     result.LocalData != null &&
    //     result.LocalData.tokenValue != null
    //   ) {
    //     let acces_token = result.LocalData.tokenValue;

    //     this.httpService
    //       .getWithHeaders(this.apiEndpointsService.getMembersEndPoint(), {
    //         headers: {
    //           Authorization: 'Bearer ' + acces_token,
    //           /*,
    //           'X-Waggle-ForceLanguage': 'en',
    //           'X-Waggle-Agent': 'GEMINI-WebClient/' + waggleAgent,
    //           'X-Waggle-APIVersion': apiVersion,
    //           'X-Waggle-RandomID': apiRandomId,*/
    //         },
    //       })
    //       .subscribe((members) => {
    //         console.log('members');
    //         console.log(members);
    //         let isMember = false;
    //         if (
    //           members != null &&
    //           members.items != null &&
    //           members.items.length > 0
    //         ) {
    //           for (let i = 0; i < members.items.length; i++) {
    //             if (!isMember && members.items[i].name == username) {
    //               isMember = true;
    //             }
    //           }
    //         }
    //         obsReturn$.next(isMember);
    //       });

    //     /*
    //     this.httpService
    //       .post(
    //         environment.GET_CONNECTIONS,
    //         {},
    //         {
    //           headers: {
    //             Authorization: 'Bearer ' + acces_token,
    //           },
    //         }
    //       )
    //       .subscribe((info) => {
    //         console.log('info');
    //         console.log(info);

    //         if (
    //           info != null &&
    //           info.version != null &&
    //           info.apiVersion != null &&
    //           info.apiRandomID != null
    //         ) {
    //           let waggleAgent = info.version;
    //           let apiVersion = info.apiVersion;
    //           let apiRandomId = info.apiRandomID;

    //           this.httpService
    //             .post(
    //               environment.GET_USER_GROUPS,

    //               [
    //                 {
    //                   ModuleName: 'XConversationModule$Server',
    //                   MethodName: 'getConversationsDetail',
    //                   Arguments: [
    //                     {
    //                       LimitToGroupWalls: true,
    //                       IncludeOpen: true,
    //                       IncludeClosed: false,
    //                       IncludeDisabled: false,
    //                       FirstResult: 0,
    //                       NumResults: 30,
    //                       SortField: 'CONVERSATION_NAME',
    //                       SortOrderDescending: false,
    //                       _class: 'XConversationDetailFilterInfo',
    //                       ExcludeMembered: false,
    //                       IncludeDiscoverable: false,
    //                     },
    //                   ],
    //                 },
    //               ],
    //               {
    //                 headers: {
    //                   Authorization: 'Bearer ' + acces_token,
    //                   'X-Waggle-ForceLanguage': 'en',
    //                   'X-Waggle-Agent': 'GEMINI-WebClient/' + waggleAgent,
    //                   'X-Waggle-APIVersion': apiVersion,
    //                   'X-Waggle-RandomID': apiRandomId,
    //                 },
    //               }
    //             )
    //             .subscribe((user_info) => {
    //               console.log('user_info');
    //               console.log(user_info);
    //             });
    //         }
    //       });*/
    //   }
    // });

    return obsReturn$; //this.httpService.get(this.apiEndpointsService.getMembersEndPoint());
  }

  getMembersVar(username: string): BehaviorSubject<Boolean> {
    let obsReturn$ = new BehaviorSubject<Boolean>(false);
    const members = MEMBERS;

    console.log('members');
    console.log(members);
    let isMember = false;


    if (
      members != null &&
      members.items != null &&
      members.items.length > 0
    ) {

      members.items.map((x) => {
        if (!isMember && x.name == username) {
          isMember = true;
        }
      })
    }

    obsReturn$.next(isMember);

    return obsReturn$;
  }

}
